import { animate, style, transition, trigger } from '@angular/animations';

export function ScaleYOutAnimation(duration: number) {
    return trigger('scaleYOut', [
        transition(':leave', [
            style({
                transform: 'scaleY(1)',
                opacity: 1
            }),
            animate(`${duration}ms cubic-bezier(0.35, 0, 0.25, 1)`, style({
                transform: 'scaleY(0)',
                opacity: 0
            }))
        ])
    ]);
}

export const scaleYOut160ms = ScaleYOutAnimation(160);